export default __webpack_public_path__ + "static/media/aptus-code-guide.badafd76.jpg";